import Box from "@mui/material/Box";
import { VIDEO_EDITOR_CLIP_COLORS, VIDEO_EDITOR_TRACK_TYPE } from "./constants";
import { getTimelineRowsLayout } from "./timelineLayout";

const GhostPreview = ({ type, sourceUrl, label }) => {
  if (type === VIDEO_EDITOR_TRACK_TYPE.IMAGE && sourceUrl) {
    return (
      <img
        src={sourceUrl}
        alt={label}
        draggable={false}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
          pointerEvents: "none",
        }}
      />
    );
  }

  if (type === VIDEO_EDITOR_TRACK_TYPE.AUDIO) {
    return <div className="video-editor-clip-waveform video-editor-clip-waveform-ghost" />;
  }

  return <div className="video-editor-clip-filmstrip-fallback" />;
};

const VideoEditorTimelineDragOverlay = ({
  edl,
  dragState,
  ghostNodeRef,
  highlightedTrackId = null,
  scrollTop = 0,
  marquee = null,
}) => {
  const layout = getTimelineRowsLayout({ edl });
  const highlightedRow = layout.rows.find(
    (row) => row.trackId === highlightedTrackId
  );
  const groupGeometries = dragState?.groupGeometries || [];

  return (
    <div className="video-editor-timeline-overlay" aria-hidden={!dragState && !marquee}>
      {highlightedRow ? (
        <div
          className="video-editor-timeline-lane-highlight"
          style={{
            top: highlightedRow.top - scrollTop,
            height: highlightedRow.height,
          }}
        />
      ) : null}
      {groupGeometries.map((item) => (
        <div
          key={item.clipId}
          className={`video-editor-timeline-ghost video-editor-timeline-ghost-${item.type}`}
          style={{
            transform: `translate3d(${item.geometry?.left || 0}px, ${
              item.geometry?.top || 0
            }px, 0)`,
            width: item.geometry?.width,
            height: item.geometry?.height,
            borderColor:
              VIDEO_EDITOR_CLIP_COLORS[item.type] ||
              VIDEO_EDITOR_CLIP_COLORS[VIDEO_EDITOR_TRACK_TYPE.VIDEO],
          }}
        >
          <GhostPreview
            type={item.type}
            sourceUrl={item.sourceUrl}
            label={item.label}
          />
        </div>
      ))}
      {dragState ? (
        <div
          ref={ghostNodeRef}
          className={`video-editor-timeline-ghost video-editor-timeline-ghost-${dragState.type}`}
          style={{
            transform: `translate3d(${dragState.geometry?.left || 0}px, ${
              dragState.geometry?.top || 0
            }px, 0)`,
            width: dragState.geometry?.width,
            height: dragState.geometry?.height,
            borderColor:
              VIDEO_EDITOR_CLIP_COLORS[dragState.type] ||
              VIDEO_EDITOR_CLIP_COLORS[VIDEO_EDITOR_TRACK_TYPE.VIDEO],
          }}
        >
          <GhostPreview
            type={dragState.type}
            sourceUrl={dragState.sourceUrl}
            label={dragState.label}
          />
          <Box className="video-editor-timeline-ghost-meta">
            <span>{dragState.label}</span>
            <span>{dragState.durationLabel}</span>
          </Box>
          {dragState.tooltip ? (
            <div className="video-editor-timeline-ghost-tooltip">
              {dragState.tooltip}
            </div>
          ) : null}
        </div>
      ) : null}
      {marquee ? (
        <div
          className="video-editor-timeline-marquee"
          style={{
            left: marquee.x,
            top: marquee.y - scrollTop,
            width: marquee.w,
            height: marquee.h,
          }}
        />
      ) : null}
    </div>
  );
};

export default VideoEditorTimelineDragOverlay;
